import { NextBranchIcon } from './ControlIcons';

export default function NextBranchPlayButton({ playing, onPlay, label, style }) {
  return <button type="button" onKeyDown={event => event.stopPropagation()} onClick={onPlay} aria-label={label} title={label}
    aria-pressed={playing} style={style}>
    <NextBranchIcon />
  </button>;
}
